import { Link } from "react-router-dom";
import { Whiteboard } from "@/components/whiteboard/Whiteboard";
import { motion } from "framer-motion";

/**
 * Landing page hero IS the product mechanic, not a stat block: a live
 * loop of the whiteboard writing itself, because the thing Soren
 * Classroom does differently from a chatbot is exactly this.
 */
export function LandingPage() {
  return (
    <div className="min-h-screen bg-paper">
      <header className="mx-auto flex max-w-6xl items-center justify-between px-4 py-6 sm:px-6">
        <span className="font-display text-lg font-semibold tracking-tight">
          Soren <span className="text-marker">Classroom</span>
        </span>
        <Link
          to="/dashboard"
          className="rounded-xl bg-ink px-4 py-2 font-body text-sm font-medium text-paper"
        >
          Enter classroom
        </Link>
      </header>

      <section className="mx-auto grid max-w-6xl gap-10 px-4 py-10 sm:px-6 lg:grid-cols-2 lg:items-center lg:py-20">
        <div>
          <h1 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            A classroom,
            <br />
            not a chat window.
          </h1>
          <p className="mt-6 max-w-md font-body text-lg text-ink/70">
            One AI teacher leads the whole lesson — speaking, writing, questioning, and
            adapting in real time. You watch it happen; you don't have to prompt it.
          </p>
          <motion.div
            className="mt-8 inline-block"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Link
              to="/dashboard"
              className="rounded-xl bg-marker px-6 py-3 font-body text-base font-medium text-paper"
            >
              Start learning
            </Link>
          </motion.div>
        </div>

        <Whiteboard title="Newton's First Law" body="An object in motion stays in motion" highlightedWord="motion" />
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            { label: "Speaks & writes together", detail: "Not a script read aloud after the board fills in." },
            { label: "Questions, then waits", detail: "Checkpoints the AI won't skip past." },
            { label: "Homework from your mistakes", detail: "Never generic — built from this lesson." },
          ].map((f) => (
            <div key={f.label} className="glass rounded-2xl p-5">
              <p className="font-display text-base font-medium">{f.label}</p>
              <p className="mt-1 font-body text-sm text-ink/60">{f.detail}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
